import { Reveal, SectionHead } from "./Reveal";

const points = [
  { title: "Mobile Service", copy: "We come to your home or workplace across the Kansas City metro." },
  { title: "Clear Recommendations", copy: "We assess the vehicle first and recommend the level of care it actually needs." },
  { title: "Price Approval", copy: "If condition or vehicle size changes the starting price, we confirm it with you before work begins." },
  { title: "Ongoing Care", copy: "Membership is available for vehicles that have been brought to and maintained at DARK standard." },
];

export const WhyDark = () => (
  <section id="why" data-testid="why-dark-section" className="py-28 sm:py-40 px-5 sm:px-8 border-t border-graphite/60">
    <div className="max-w-7xl mx-auto">
      <SectionHead
        index="04"
        overline="Why DARK"
        title="Premium care without the guesswork."
        copy="A clear process, condition-based recommendations, and mobile service built around your schedule."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-12 mt-16">
        {points.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.07}>
            <div
              data-testid={`why-point-${i}`}
              className="border-t border-graphite pt-7 hover:border-volt transition-colors duration-500"
            >
              <h3 className="font-accent text-xs tracking-[0.3em] uppercase text-ivory">{p.title}</h3>
              <p className="text-silver/70 text-sm leading-relaxed mt-4">{p.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
